import styles from "./index.module.scss";

const PageMarker = ({ page, total }: { page: number; total: number }) => {
  return (
    <div className={styles.pageMarker}>
      {/* eslint-disable jsx-a11y/anchor-is-valid*/}
      <a id={`p${page}`}>
        PAGE {page} OF {total}
      </a>
      {/* eslint-enable jsx-a11y/anchor-is-valid*/}
    </div>
  );
};

export default PageMarker;
